import React from "react"
import OrganizationDetails from "../App/OrganizationDetails"

import "./styles.css"

export default function Sidebar({ children }) {

  const currentYear = new Date().getFullYear()

  return (
    <div className="sidebar custom-scrollbars">

      <OrganizationDetails />

      <ul className="sidebarItems pl-10 pv-10">
        { children }
      </ul>

      <div className="sidebar-footer p-10">
        <p className="align-center">
          <span>
            &copy; { currentYear } Aion Sigma, Inc.
            <br/>
            All Rights Reserved
          </span>
        </p>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js